module.exports = __webpack_public_path__ + "img/logo-dark.94e0007a.png";